import axios from "axios"

export const kenzieAPI = axios.create({
    baseURL: "https://kenziehub.herokuapp.com",
    timeout: 5000
})